var map = {
	"./icons_action.png": 16,
	"./icons_action_desktop.png": 17,
	"./icons_activityLevel_0.png": 61,
	"./icons_activityLevel_1.png": 62,
	"./icons_activityLevel_2.png": 63,
	"./icons_activityLevel_3.png": 64,
	"./icons_activityLevel_4.png": 65,
	"./icons_airExchangeRate_0.png": 66,
	"./icons_airExchangeRate_1.png": 67,
	"./icons_airExchangeRate_2.png": 68,
	"./icons_airExchangeRate_3.png": 69,
	"./icons_airExchangeRate_4.png": 70,
	"./icons_all_0.png": 71,
	"./icons_all_1.png": 72,
	"./icons_all_2.png": 73,
	"./icons_all_3.png": 74,
	"./icons_arrow.png": 18,
	"./icons_arrow_down_1.png": 75,
	"./icons_criticalDose_0.png": 76,
	"./icons_criticalDose_1.png": 77,
	"./icons_emitterType_0.png": 78,
	"./icons_emitterType_1.png": 79,
	"./icons_emitterType_2.png": 80,
	"./icons_emitterType_3.png": 81,
	"./icons_maskEfficiencyExhaled_0.png": 82,
	"./icons_maskEfficiencyExhaled_1.png": 83,
	"./icons_maskEfficiencyExhaled_2.png": 84,
	"./icons_maskEfficiencyExhaled_3.png": 85,
	"./icons_maskEfficiencyExhaled_4.png": 86,
	"./icons_maskEfficiencyInhaled_0.png": 87,
	"./icons_maskEfficiencyInhaled_1.png": 88,
	"./icons_maskEfficiencyInhaled_2.png": 89,
	"./icons_maskEfficiencyInhaled_3.png": 90,
	"./icons_maskEfficiencyInhaled_4.png": 91,
	"./icons_person_0.png": 92,
	"./icons_person_1.png": 93,
	"./icons_roomVolume_0.png": 94,
	"./icons_roomVolume_1.png": 95,
	"./icons_roomVolume_2.png": 96,
	"./icons_roomVolume_3.png": 97,
	"./icons_roomVolume_4.png": 98,
	"./icons_szenario_doctor.png": 99,
	"./icons_szenario_party.png": 100,
	"./icons_szenario_school.png": 101,
	"./icons_teaser.png": 102,
	"./icons_timeInRoom_0.png": 103,
	"./icons_timeInRoom_1.png": 104,
	"./icons_timeInRoom_2.png": 105,
	"./icons_timeInRoom_3.png": 106,
	"./icons_timeInRoom_4.png": 107,
	"./icons_voiceStrengths_0.png": 108,
	"./icons_voiceStrengths_1.png": 109,
	"./icons_voiceStrengths_2.png": 110,
	"./icons_voiceStrengths_3.png": 111,
	"./icons_voiceStrengths_4.png": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;